import { ChainId, ChainLayer } from '@cronos-app/sdk';

import { getAgentFunToken } from './registers/agentfun';
import { getVUsdToken } from './registers/vusd';
import { getWcroToken } from './registers/wcro';
import { getWzkCroToken } from './registers/wzkcro';
import { getZkCroToken } from './registers/zkcro';
import type { NormalToken, TokenConfig } from './types';
import { Token } from './types';

const getConfigByNetwork = (
  chainId: ChainId,
): Record<NormalToken, TokenConfig> => {
  return {
    [Token.agentFun]: getAgentFunToken(chainId),
    [Token.zkCRO]: getZkCroToken(chainId),
    [Token.wzkCRO]: getWzkCroToken(chainId),
    [Token.vUSD]: getVUsdToken(chainId),
    [Token.wCRO]: getWcroToken(chainId),
  };
};

export const GAS_TOKEN: Record<ChainLayer, NormalToken> = {
  [ChainLayer.L2]: Token.zkCRO,
  [ChainLayer.CronosEvm]: Token.wCRO,
};

export const TOKEN_CONFIG_MAP: Record<
  ChainId,
  Record<NormalToken, TokenConfig>
> = {
  [ChainId.CRONOS_ZK_MAINNET]: getConfigByNetwork(ChainId.CRONOS_ZK_MAINNET),
  [ChainId.CRONOS_ZK_TESTNET]: getConfigByNetwork(ChainId.CRONOS_ZK_TESTNET),
  [ChainId.CRONOS_EVM_MAINNET]: getConfigByNetwork(ChainId.CRONOS_EVM_MAINNET),
  [ChainId.CRONOS_EVM_TESTNET]: getConfigByNetwork(ChainId.CRONOS_EVM_TESTNET),
};

const ALL_TOKEN_LIST: NormalToken[] = [
  Token.agentFun,
  Token.vUSD,
  Token.wzkCRO,
  Token.zkCRO,
];

const getTokenListByNetwork = (desiredNetwork: ChainId): NormalToken[] => {
  return ALL_TOKEN_LIST.filter(
    (type) => !!TOKEN_CONFIG_MAP[desiredNetwork][type].address,
  );
};

export const TOKEN_LIST: Record<ChainId, NormalToken[]> = {
  [ChainId.CRONOS_ZK_MAINNET]: getTokenListByNetwork(ChainId.CRONOS_ZK_MAINNET),
  [ChainId.CRONOS_ZK_TESTNET]: getTokenListByNetwork(ChainId.CRONOS_ZK_TESTNET),
  [ChainId.CRONOS_EVM_MAINNET]: getTokenListByNetwork(
    ChainId.CRONOS_EVM_MAINNET,
  ),
  [ChainId.CRONOS_EVM_TESTNET]: getTokenListByNetwork(
    ChainId.CRONOS_EVM_TESTNET,
  ),
};
